module.exports = __webpack_public_path__ + "static/2.2moveObject-273812c5eaef02dc6b1da7e43ea42666.gif";